import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { useAddNoteModal } from '../context/AddNoteModalContext';

const AddNoteModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddNoteModal();

  const modalTitle =
    data.modalActionType === actionTypes.EDIT
      ? t('EditAnnotation')
      : t('AddAnnotation');

  return (
    <Modal.Header>
      <h5 className="modal-title">{modalTitle}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddNoteModalHeader;
